import React from "react";
import ObjectSelectedSensorsRows from "./ObjectSelectedSensorsRows";
import ObjectParameters from "./ObjectParameters";
import trans, { isRTL } from "../../../../utils";
import {
	AltitudeUnit,
	DistanceUnit,
	SpeedUnit,
} from "../../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function ObjectSelectedSensors({ position, CarSensors }) {
	const inf = useSelector((state) => state.users.user);
	function convertMillisecondsToTime(ms) {
		const totalMinutes = Math.floor(ms / 60000); // Convert ms to minutes
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;
		if (isRTL) {
			return `${hours}س ${minutes}د`;
		} else {
			return `${hours}h ${minutes}m`;
		}
	}
	return (
		<>
			{position && (
				<div className="object-selected-sensors">
					<ObjectSelectedSensorsRows
						title={"speed"}
						val={`${SpeedUnit(position?.speed, inf?.attributes?.speedUnit)}`}
						img="baselinespeed"
						position={position}
					/>
					{CarSensors?.fuelSupport && (
						<ObjectSelectedSensorsRows title="fuel" val="N/A" img="Fuel" />
					)}
					{CarSensors?.temperatureSensorSupport && (
						<ObjectSelectedSensorsRows
							title="temperature"
							val="N/A"
							img="Temperature"
							position={position}
						/>
					)}
					{CarSensors?.accSupport && (
						<ObjectSelectedSensorsRows
							title="ignition"
							val="OFF"
							img="Ignition"
							position={position}
						/>
					)}
					{CarSensors?.doorSupport && (
						<ObjectSelectedSensorsRows title="door" val="Closed" img="Door" />
					)}
					{Object.keys(position?.attributes).length !== 0 && (
						<>
							<div className="parameters mb-2">
								<div>{trans("Parameters")}</div>
							</div>
							{Object.entries(position?.attributes).map(([key, value]) => {
								// Format value based on the key
								let formattedValue;

								if (
									[
										"odometer",
										"totalodometer",
										"distance",
										"totalDistance",
									].includes(key)
								) {
									formattedValue = `${DistanceUnit(
										value,
										inf?.attributes?.distanceUnit
									)}`;
								} else if (key === "hours") {
									formattedValue = convertMillisecondsToTime(value);
								} else if (typeof value === "boolean") {
									formattedValue = value ? trans("ON") : trans("OFF");
								} else {
									formattedValue = Math.round(value * 10) / 10;
								}

								return (
									<div key={key} className="flex-between display-border p-8">
										<div className="parameter-title">{trans(key)}</div>
										<div>{formattedValue}</div>
									</div>
								);
							})}

							<ObjectParameters name={"protocol"} item={position.protocol} />
							{position?.protocol !== "meitrack" ? (
								<ObjectParameters
									name="network"
									item={position.network ? position.network : "- - - -"}
								/>
							) : (
								<>
									<ObjectParameters
										name="cell id"
										item={position.network?.cellTowers[0]?.cellId}
									/>
									<ObjectParameters
										name="location area code"
										item={position.network?.cellTowers[0]?.locationAreaCode}
									/>
									<ObjectParameters
										name="mobile country code"
										item={position.network?.cellTowers[0]?.mobileCountryCode}
									/>
									<ObjectParameters
										name="mobile network code"
										item={position.network?.cellTowers[0]?.mobileNetworkCode}
									/>
									<ObjectParameters
										name="signal strength"
										item={position.network?.cellTowers[0]?.signalStrength}
									/>
									<ObjectParameters
										name="consider ip"
										item={
											position.network?.considerIp === true
												? trans("ON")
												: trans("False")
										}
									/>
									<ObjectParameters
										name="radio type"
										item={position.network?.radioType}
									/>
								</>
							)}
							<ObjectParameters
								name="valid"
								item={position.valid ? trans("True") : trans("False")}
							/>
							<ObjectParameters
								name="outdated"
								item={position.outdated ? trans("True") : trans("False")}
							/>
							<ObjectParameters name="latitude" item={position.latitude} />
							<ObjectParameters name="longitude" item={position.longitude} />
							<ObjectParameters
								name="altitude"
								item={AltitudeUnit(
									position.altitude,
									inf?.attributes.altitudeUnit
								)}
							/>
							<ObjectParameters
								name="device time"
								item={position.deviceTime}
								type="date"
							/>
							<ObjectParameters
								name="fix time"
								item={position.fixTime}
								type="date"
							/>
							<ObjectParameters
								name="server time"
								item={position.serverTime}
								type="date"
							/>
						</>
					)}
				</div>
			)}
		</>
	);
}
